export const ALERT_TYPES = {
  ANNOUNCEMENT: 1,
  MESSAGE_CENTER: 2,
  LATE_RENT: 3,
  SIGN_LEASE: 4,
  RENEWAL_OFFER: 5,
  INSPECTION: 6,
  ESIGN: 7,
  PARCEL: 8,
  OPT_OUT_EMAIL_INVOICES: 9,
  OPT_IN_SMS: 10,
  SCHEDULED_CHARGE: 11,
  RATING_AND_REVIEW: 12,
  AR_PAYMENT_RETURN: 13,
  SCHEDULED_PAYMENT_RETURN: 14,
  APPROVE_SPLIT_AUTO_PAYMENT: 15,
  PAUSED_SCHEDULED_PAYMENT: 16,
  MOVE_IN_CHECKLIST: 17,
  MOVE_OUT_CHECKLIST: 18,
  RELINK_PAYMENT_ACCOUNT: 20,
  SCHEDULED_MOVE_IN: 21,
  INSURANCE_POLICY: 28,
  CREATE_AUTO_PAYMENT: 31
}
